var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    stroke: "white",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69715 2.07799C9.84325 1.9319 10.0167 1.81601 10.2076 1.73695C10.3984 1.65788 10.603 1.61719 10.8096 1.61719C11.0162 1.61719 11.2208 1.65788 11.4117 1.73695C11.6026 1.81601 11.776 1.9319 11.9221 2.07799C12.0682 2.22409 12.1841 2.39753 12.2632 2.58841C12.3422 2.77929 12.3829 2.98387 12.3829 3.19048C12.3829 3.39709 12.3422 3.60167 12.2632 3.79255C12.1841 3.98343 12.0682 4.15687 11.9221 4.30296L4.41285 11.8122L1.35352 12.6466L2.18788 9.58727L9.69715 2.07799Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconDark);
export default __webpack_public_path__ + "static/media/edit-icon-dark.1d15a4128c1805eaf539954d26741227.svg";
export { ForwardRef as ReactComponent };